import React, { memo } from 'react';
import classnames from 'classnames';
import Element from 'src/components/base/element';

interface IProps {
    className?: string;
    children: React.ReactNode;
    position: 'center' | 'right' | 'left';
}

function MediaItem(props: IProps) {
    const { className, children, position } = props;
    const p = position === 'center' ? 'content' : position;
    return (
        <Element
            {...props}
            className={classnames(className, {
                [`media-${p}`]: p,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(MediaItem);
